export function getSessionAuth() {
  return {
    token: sessionStorage.getItem("token") || "",
    userId: sessionStorage.getItem("user") || "",
  };
}

export function getSessionUserId() {
  return getSessionAuth().userId;
}

export function getSessionToken() {
  return getSessionAuth().token;
}

export function isAuthenticated() {
  const { token, userId } = getSessionAuth();
  return Boolean(token && userId);
}

export function clearSession() {
  sessionStorage.removeItem("token");
  sessionStorage.removeItem("user");
  sessionStorage.removeItem("toUserID");
  sessionStorage.removeItem("roomID");
}
